import React from 'react';
import { connect } from 'react-redux';

import Indicator from '../../components/indicator';

const mapStateToProps = ({ global }) => ({
  databaseLoaded: global.loadedResources.database
});

export default function(Component) {
  const WithDatabase = ({ databaseLoaded, ...props }) => {
    if (!databaseLoaded) {
      return <Indicator spin />;
    }
    return <Component {...props} />;
  };

  return connect(mapStateToProps)(WithDatabase);
}
